<script>
  import { createEventDispatcher } from 'svelte';

  import { InlineNotification, Modal } from 'carbon-components-svelte';

  import LoadingSpinner from '../../components/LoadingSpinner.svelte';
  import { removeUserFromGroup } from '../../services';
  import { getServerErrorMessage } from '../../utils';

  export let groupId;
  export let open = false;
  export let user;

  let loading = false;
  let resultNotification;

  const dispatch = createEventDispatcher();

  async function removeFromGroup() {
    loading = true;
    try {
      await removeUserFromGroup(groupId, user.id);

      dispatch('submit');
      dispatch('close');
    } catch (error) {
      const errorMessage = getServerErrorMessage(error) ?? 'Verify your submission and try again!';
      console.error('[RemoveUserFromGroupModal] Failed to remove user from group!', errorMessage);
      resultNotification = {
        hideCloseButton: false,
        kind: 'error',
        title: 'Error:',
        subtitle: `Failed to remove user from group! ${errorMessage}`,
      };
    } finally {
      loading = false;
    }
  }

  function onModalClose() {
    dispatch('close');
  }
</script>

<Modal
  danger
  modalHeading="Remove User from Group"
  preventCloseOnClickOutside={true}
  primaryButtonText="Remove"
  secondaryButtonText="Cancel"
  size="sm"
  bind:open
  on:click:button--secondary={onModalClose}
  on:close={onModalClose}
  on:submit={removeFromGroup}
>
  <LoadingSpinner {loading}>
    {#if resultNotification}
      <InlineNotification
        kind={resultNotification.kind}
        lowContrast
        title={resultNotification.title}
        subtitle={resultNotification.subtitle}
      />
    {/if}
    <p>
      You are about to remove {user?.email} from this group. The user's associated roles will also be removed. Are you sure?
    </p>
  </LoadingSpinner>
</Modal>
